// JsFromRoutes CacheKey 884e3e130450aaf936cc1f3f16608df0
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/api/workspace/:venue_slug/deals'),
  create: /* #__PURE__ */ definePathHelper('post', '/api/workspace/:venue_slug/deals'),
  new: /* #__PURE__ */ definePathHelper('get', '/api/workspace/:venue_slug/deals/new'),
  edit: /* #__PURE__ */ definePathHelper('get', '/api/workspace/:venue_slug/deals/:id/edit'),
  show: /* #__PURE__ */ definePathHelper('get', '/api/workspace/:venue_slug/deals/:id'),
  update: /* #__PURE__ */ definePathHelper('patch', '/api/workspace/:venue_slug/deals/:id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/api/workspace/:venue_slug/deals/:id'),
}
